import React from "react";
import { ReactNode } from "react";

import { css } from "@emotion/core";

import { Text } from "@zapier/design-system";

import PaymentMethodImage from "@zapier/payment/esm/components/PaymentMethodImage";
import {
  PayPalPaymentSource,
  PaymentSourceType,
} from "@zapier/payment/esm/types";

type ChildrenProps = {
  /** Paypal Payment source details */
  paypal: PayPalPaymentSource["details"];
};

type Props = {
  children?: (a: ChildrenProps) => ReactNode;

  /** Show compact version of info */
  isCompact?: boolean;
} & ChildrenProps;

const detailsCss = (isCompact = false) =>
  css({
    marginLeft: isCompact ? 9 : 15,
  });

const breakWordCss = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const wrapperCss = {
  alignItems: "center",
  display: "flex",
};

const PaypalInfo = ({ isCompact = false, ...props }: Props) => {
  return (
    <div css={wrapperCss}>
      <PaymentMethodImage
        imageType={PaymentSourceType.paypal}
        isSmall={isCompact}
      />
      <div css={[detailsCss(isCompact), breakWordCss]}>
        <Text type={isCompact ? "paragraph3" : "paragraph3Bold"}>
          {props.paypal?.email}
        </Text>
      </div>
    </div>
  );
};

export default PaypalInfo;
